<template>
    <four-column-grid-section
        class="four-column-grid-section-module"
        :title="attributes.fourColumnGridSection_title"
        :columns="columns"
        :background-variant="attributes.fourColumnGridSection_background_variant"
        :grid-type="attributes.fourColumnGridSection_grid_type"
    />
</template>

<script>
    import FourColumnGridSection from '../../../organisms/FourColumnGridSection/FourColumnGridSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';
    import ThreeColumnGridSection from '../../../organisms/ThreeColumnGridSection/ThreeColumnGridSection.vue';

    export default {
        name: 'four-column-grid-section-module',

        components: { ThreeColumnGridSection, FourColumnGridSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format the columns for the FourColumnGridSection component.
             *
             * @returns {Array<{image: {src: string|undefined|null, alt: string|undefined|null}, text: string}>}
             */
            columns() {
                return [
                    {
                        image: formatMediaObject.call(this, this.attributes.fourColumnGridSection_column_1_image),
                        text: this.attributes.fourColumnGridSection_column_1_text,
                    },
                    {
                        image: formatMediaObject.call(this, this.attributes.fourColumnGridSection_column_2_image),
                        text: this.attributes.fourColumnGridSection_column_2_text,
                    },
                    {
                        image: formatMediaObject.call(this, this.attributes.fourColumnGridSection_column_3_image),
                        text: this.attributes.fourColumnGridSection_column_3_text,
                    },
                    {
                        image: formatMediaObject.call(this, this.attributes.fourColumnGridSection_column_4_image),
                        text: this.attributes.fourColumnGridSection_column_4_text,
                    },
                ].filter(({ text }) => text);
            },
        },
    };
</script>
